import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { FormController } from './FormController';
import { dateToUTC, handleError } from './Functions';

export function AddModal({ setShow, show, setLoading, loading, addEndpoint, keys, modelName, parentId, parentsParentId, parent, parentValues, canReadUserRoles, canReadServiceAddresses, canReadMeters, successMessage, successCallback, districtId }) {
    const [model, setModel] = useState<any>();

    useEffect(() => {
        if(show){
            var newModel = {};
            Object.keys(keys).forEach(key => {
                if(parent && parentValues.includes(key)){
                    newModel[key] = parent.id
                } else if(key === "isActive" || key === "isSaved") {
                    newModel[key] = true
                } else {
                    newModel[key] = ""
                }
            })
            setModel(newModel)
        }
    }, [keys, parentId, show])// eslint-disable-line react-hooks/exhaustive-deps

    const handleCancel = () => {
        setModel(null)
        setShow(false)
    }

    const handleAdd = async event => {
        event.preventDefault();
        let addModel = {};
        for (var obj in model) {
            if(model[obj] !== "")
                addModel[obj] = model[obj];
            if(obj.toLowerCase().endsWith("date"))
                addModel[obj] = dateToUTC(new Date(new Date(new Date(model[obj]).setDate(1+new Date(new Date(model[obj])).getDate())).setHours(0)))
        }
        if(parentsParentId){
            addEndpoint(parentsParentId, parentId, addModel)
                .then(() => {
                    if(successMessage){
                        successCallback(successMessage)
                    }
                    setLoading(!loading)
                })
                .catch(err => handleError(err))
        } else if(parentId){
            addEndpoint(parentId, addModel)
                .then(() => {
                    if(successMessage){
                        successCallback(successMessage)
                    }
                    setLoading(!loading)
                })
                .catch(err => handleError(err))
        } else {
            addEndpoint(addModel)
                .then(() => {
                    if(successMessage){
                        successCallback(successMessage)
                    }
                    setLoading(!loading)
                })
                .catch(err => handleError(err))
        }

        handleCancel();
    };

    if(!model) return null;

    return (
        <Dialog
            open={true}
            onClose={handleCancel}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Add {modelName}</DialogTitle>
            <DialogContent>
                <FormController
                    keys={keys}
                    disabledKeys={parentValues}
                    extraKeys={null}
                    editMode={true}
                    model={model}
                    setModel={setModel}
                    canReadUserRoles={canReadUserRoles}
                    canReadMeters={canReadMeters}
                    canReadServiceAddresses={canReadServiceAddresses}
                    districtId={districtId} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>
                    Cancel
                </Button>
                <Button
                    onClick={handleAdd}
                    color="primary"
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}